import styled from 'styled-components';
import { FiUserPlus } from 'react-icons/fi';
import ReactSelect from 'react-select';

export const Container = styled.div`
  height: 100%;
  display: flex;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const Select = styled(ReactSelect)`
  margin: 1rem 0;
  max-width: 400px;
  width: 100% !important;
`;

export const MainContent = styled.div`
  padding: 1rem;
`;

export const MainTitle = styled.p`
  padding: 1rem;
  font-size: 1rem;
  font-weight: bold;
  color: var(--text-body);
  border-bottom: 1px solid var(--black-light);
`;

export const ButtonPrimary = styled.button`
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;
  max-width: 250px;
  height: 45px;
  background-color: var(--primary);
  color: var(--white);
  border-radius: 10px;
  transition: background-color 0.3s;
  text-transform: uppercase;

  &:hover {
    background: var(--primary-hover);
  }

  & + button {
    margin-left: 0.5rem;
  }
`;

export const ButtonDownload = styled.button`
  display: flex;
  align-items: center;
  padding: 0.5rem;
  height: 45px;
  background-color: var(--white);
  font-weight: bold;
  border-radius: 10px;
  border: 3px solid #444444;
  color: #777777;
  transition: background-color 0.3s;
  cursor: pointer;
  width: fit-content;

  &:hover {
    color: #444444;
  }

  & + button {
    margin-left: 0.5rem;
  }
`;

export const IconUserPlus = styled(FiUserPlus)`
  font-size: 18px;
  margin-right: 1rem;
`;

export const SectionFilter = styled.div`
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
  display: flex;
`;

export const InputSearch = styled.input`
  border: 2px solid var(--black-light);
  border-radius: 10px;
  padding: 0rem 1rem;
  max-width: 320px;
  margin-right: 0.5rem;
  width: 100%;
`;

export const SectionListUsers = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;
  max-height: 580px;
  overflow-y: auto;
`;

export const HeaderListUsers = styled.div`
  display: flex;
  align-items: center;
  margin-top: 2rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--text-body-clean);

  p {
    text-align: center;
    max-width: 150px;
    width: 100%;
  }

  span {
    text-align: center;
    max-width: 80px;
    width: 100%;
  }

  div {
    margin-left: auto;
    width: 60px;
  }
`;

export const ItemUser = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid var(--text-body-clean);
  padding: 0.5rem;

  & + & {
    margin-top: 1rem;
  }

  p {
    text-align: center;
    max-width: 150px;
    width: 100%;
  }

  span {
    text-align: center;
    max-width: 80px;
    width: 100%;
  }

  div {
    margin-left: auto;
    width: 60px;
    display: flex;
    justify-content: space-between;

    svg {
      font-size: 20px;
      cursor: pointer;
    }
  }
`;

export const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;

  span {
    background-color: var(--black-light);
    font-size: 1.125rem;
    padding: 0.5rem 1rem;
    margin: 0 0.125rem;
  }
`;

export const ArrowLeft = styled.button`
  background-color: var(--primary);
  padding: 0.5rem 1rem;
  color: var(--white);
  border-radius: 5px;
  cursor: pointer;

  svg {
    font-size: 17px;
  }

  &:disabled {
    background-color: var(--background-modal);
  }
`;

export const ArrowRight = styled.button`
  background-color: var(--primary);
  color: var(--white);
  padding: 0.5rem 1rem;
  border-radius: 5px;
  cursor: pointer;

  svg {
    font-size: 17px;
  }

  &:disabled {
    background-color: var(--background-modal);
  }
`;
